import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {utcToLocal} from '../../utils/dateConvert'

class EventTable extends Component {
    render() {
        return (
            <div className="events-table-wrap">
                
            <Table className="events-modern-table">
<thead>
<tr>
  
  <th>Name</th>
  <th>Description</th>
  <th>Type</th>
  <th>Configuration</th>
  <th>Status</th>
  <th>Created</th>
  <th>Updated</th>
  <th className="events-actions-heading"></th>


</tr>
</thead>
<tbody>
 {this.props.EventsList.length === 0 && (
     <tr>
         <td className="events-empty" colSpan="8">
             No events match your search.
         </td>
     </tr>
 )}
    
 {this.props.EventsList.map((events,index)=>{
     const normalizedStatus = (events.status || "").toString().toLowerCase();
     const status = normalizedStatus === "0" || normalizedStatus === "disabled" || normalizedStatus === "disable" ? 'Disabled':'Active';
     return(    <tr key={events.id || index}>
          <td><strong>{events.name || "-"}</strong></td>
          <td>{events.description || "-"}</td>
          <td>{events.type || "-"}</td>
          <td>{events.config || "-"}</td>
          <td>
              <span className={`events-status events-status-${status.toLowerCase()}`}>
                  {status}
              </span>
          </td>
          <td>{utcToLocal(events.dbCreated)}</td>
          <td>{utcToLocal(events.dbUpdated)}</td>
          <td className="events-actions">
              <Link to={`/editEvent/${events.id}`}>Edit</Link>
              <Link to={`/eventDetails/${events.id}`}>Details</Link>
              <Link to={`/eventDelete/${events.id}`}>Delete</Link>
          </td>
        </tr>
       )
 })} 

</tbody>
</Table>
        </div>
        );
    }
}

export default EventTable;
